import { CustomTableCell, CustomTableHead, FormSectionHeader, Heading, Loader, NoData } from "@/components";
import { Button, Card, CardContent, Table, TableBody, TableHeader, TableRow } from "@/components/ui";
import useManualEntry from "./useManualEntry";
import { Trash2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { isFieldSkipped } from "./consts";
import { FormProvider } from "react-hook-form";

const ManualEntry = () => {
  const {
    form,
    renderDynamicField,
    headerFields,
    lineItemRows,
    lineItemFields,
    removeRow,
    addRow,
    onSubmit,
    balanceAmount,
    isRefetchingConfigFields,
    fieldDisabled,
    isListLoading,
    isLoading,
    breadcrumbData,
    onBackClick,
    isPostPending,
    isDraft,
    isSubmitPending,
    onSubmitForApproval,
    isVI,
    canPost
  } = useManualEntry();

  return (
    <div className="p-4 md:p-6">
    {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={breadcrumbData[breadcrumbData?.length - 1]?.name || ""}
            breadcrumbData={breadcrumbData}
          />
        </div>
      </div>
      <div className="flex flex-col gap-5 w-full max-w-full overflow-hidden">
        {/* <div>
          Balance Amount: {balanceAmount || 0}
        </div> */}
        {isListLoading || isLoading ? <Loader /> : 
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-5">
              <Card className="rounded-md overflow-hidden">
                <CardContent className="overflow-hidden">
                  <FormSectionHeader>Document Header</FormSectionHeader>
                  {isRefetchingConfigFields ? <Loader /> : 
                    headerFields?.length ?
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
                        {headerFields?.map((field: any) => {
                          if (isFieldSkipped(field.fieldName)) return <></>
                          return renderDynamicField(field, form)
                        })}
                      </div> :
                      <NoData />
                  }
                </CardContent>
              </Card>
              <Card className="p-0">
                <CardContent className="px-0 !py-4">
                  <div className="flex flex-row items-center justify-between pb-4">
                    <FormSectionHeader className="px-6" wrapperClassName="mb-0">Line Items</FormSectionHeader>
                    {isRefetchingConfigFields ? <></> : !fieldDisabled && headerFields?.length ? <Button variant="link" onClick={addRow} type="button">+ Add Line Item</Button> : <></>}
                  </div>
                  {isRefetchingConfigFields ? <Loader /> : 
                    lineItemRows?.length ? 
                      <div className="overflow-x-auto w-full block clear-both">
                        <Table className="min-w-max w-full table-auto">
                          <TableHeader>
                            <TableRow className="mb-3 rounded">
                              {lineItemFields.map((field: any) => {
                                if (isFieldSkipped(field.fieldName)) return <></>
                                return (
                                  <CustomTableHead key={field.fieldName} className={cn(field.fieldName == "delete" ? "w-[80px]" : 'w-[200px]')}>
                                    {field.fieldName == "budgetYear" ? "Budget Month & Year" : field.displayLabel}
                                  </CustomTableHead>
                                )
                              })}
                            </TableRow>
                          </TableHeader>
                          <TableBody>
                            {lineItemRows.map((_, index) => (
                              <TableRow>
                                {lineItemFields.map((field: any) => {
                                  if (isFieldSkipped(field.fieldName)) return <></>
                                  return (
                                    <CustomTableCell key={field.fieldName} className="pb-7">
                                      {field?.fieldName == "delete" ? fieldDisabled ? <></> :
                                        <Trash2 className="stroke-red-600 h-5 w-5" onClick={() => removeRow(index)} /> :
                                        renderDynamicField(field, form, index)}
                                    </CustomTableCell>
                                  )
                                  })}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </div> :
                      <NoData />
                  }
                </CardContent>
              </Card>

              <div className="flex items-end justify-end gap-3">
                <Button type="button" variant="outline" disabled={isPostPending || isSubmitPending} onClick={onBackClick}>Cancel</Button>
                {isVI && isDraft && headerFields?.length ? 
                  <Button type="button" disabled={balanceAmount != 0 || isSubmitPending} onClick={onSubmitForApproval}>{isSubmitPending ? <Loader variant="secondary" /> : <></>} Submit for Approval</Button> 
                  : <></>}
                {canPost ? 
                  <Button type="submit" disabled={balanceAmount != 0 || isPostPending}>{isPostPending ? <Loader variant="secondary" /> : <></>} Post</Button> 
                  : <></>}
              </div> 
            </div>
          </form>
        </FormProvider>}
      </div>
    </div>
  )
}

export default ManualEntry;